import { ComponentPropsWithoutRef, ReactNode } from 'react';

import classNames from 'classnames';
import { Popover } from 'radix-ui';

import { comboboxStyles } from '../combobox.styles';
import { useComboboxContext } from '../ComboboxContext';

export interface ComboboxDropdownProps extends ComponentPropsWithoutRef<'div'> {
  children?: ReactNode;
}

export const ComboboxDropdown = ({ className, children, ...rest }: ComboboxDropdownProps) => {
  const { classNames: contextClassNames } = useComboboxContext();
  const styles = comboboxStyles();

  return (
    <Popover.Portal>
      <Popover.Content
        sideOffset={4}
        align="start"
        onOpenAutoFocus={(e) => e.preventDefault()}
        onMouseDown={(e) => e.preventDefault()}
        style={{ width: 'var(--radix-popover-trigger-width)' }}
      >
        <div
          {...rest}
          className={classNames(styles.dropdown(), contextClassNames?.dropdown, className)}
        >
          {children}
        </div>
      </Popover.Content>
    </Popover.Portal>
  );
};
